/**
 * @name FrameQueue
 * @description Used to provide a more performance friendly method for requesting animation frames.
 *              Instead of requesting many animation frames and each being called separately,
 *              each request is queued until the frame is ready then all items in the queue are
 *              processed at once.
 */
export class FrameQueue {
  constructor() {
    this._queue = [];
    this._waitingForFrame = false;
  }

  /**
   * @name add
   * @description Add a new item to the frame queue.
   *
   * @param {Function} item Function to be called on the next frame.
   */
  add(item) {
    this._queue.push(item);

    this._runQueue();
  }

  /**
   * @name _runQueue
   * @description Attempts to process the queue.
   *              If a frame has already been requested then do nothing.
   */
  _runQueue() {
    if (!this._waitingForFrame) {
      this._waitingForFrame = true;

      window.requestAnimationFrame(this._processQueue.bind(this));
    }
  }

  /**
   * @name _processQueue
   * @description Processes all items currently in the queue.
   *
   * @param {Number} time Current frame timestamp.
   */
  _processQueue(time) {
    // Buffer is used to clear the main queue as fast as possible.
    const queueBuffer = this._queue;
    this._queue = [];

    queueBuffer.forEach(item => {
      if (typeof item === 'function') {
        item(time);
      }
    });

    this._waitingForFrame = false;

    if (this._queue.length > 0) {
      this._runQueue();
    }
  }
}
